<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off">
  <div nz-row [nzGutter]="['0','0']">
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="diplomaCode" nzRequired #label>Mã</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập mã">
          <input nz-input formControlName="diplomaCode" name="diplomaCode" type="text" placeholder="Nhập mã"
            [jAutofocus]>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="diplomaName" nzRequired #label>Tên đào tạo bồi dưỡng về giáo dục người khuyết tật
        </nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập tên đào tạo bồi dưỡng về giáo dục NKT">
          <input nz-input formControlName="diplomaName" type="text" placeholder="Nhập tên đào tạo bồi dưỡng về giáo dục NKT">
        </nz-form-control>
      </nz-form-item>
    </div>
    <div nz-col nzSm="24" nzMd="24">
      <nz-form-item>
        <nz-form-label nzSpan="24" nzFor="displayOrder" nzRequired #label>Cấp độ</nz-form-label>
        <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập cấp độ!">
          <nz-input-number formControlName="displayOrder" [nzMin]="1" [nzStep]="1" placeholder="Nhập cấp độ">
          </nz-input-number>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Lưu &
        Đóng</button>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
      <button nz-button (click)="close()" [disabled]="isDisabled">Đóng</button>&nbsp;
      <button nz-button nzType="primary" (click)="UpdateClose()" [disabled]="isDisabled" type="submit">Sửa</button>
    </div>
  </div>
</form>
